$(document).ready(function () {
    //Changes the src of the primary images when a thumbnail item is clicked
    $("[name='thumbImages']").on('click', function(event) {
        event.stopPropagation();
        event.stopImmediatePropagation();

        console.log(this.getAttribute('src'));
        
        $('#ProductPhotoImg').attr("src", this.getAttribute('src').replace("small", "large"));
        $('#modalImage').attr("src", this.getAttribute('src').replace("small", "large"));
    })

});